export enum SvcModalActionPlanStatusId {
  Atrasado = 10,
  NoPrazo = 20,
  EmAprovacao = 30,
  Concluido = 40,
  Cancelado = 50,
}

export const SvcModalActionPlanStatusTypeById: Record<number, 'late' | 'ontime' | 'approval' | 'completed' | 'inactive'> = {
  // Backend IDs (1-based)
  1: 'ontime',
  2: 'late',
  3: 'approval',
  4: 'completed',
  5: 'inactive',
  // Legacy frontend IDs (10-based)
  [SvcModalActionPlanStatusId.Atrasado]: 'late',
  [SvcModalActionPlanStatusId.NoPrazo]: 'ontime',
  [SvcModalActionPlanStatusId.EmAprovacao]: 'approval',
  [SvcModalActionPlanStatusId.Concluido]: 'completed',
  [SvcModalActionPlanStatusId.Cancelado]: 'inactive',
};

export const SvcModalActionPlanStatusLabelById: Record<number, string> = {
  // Backend IDs (1-based)
  1: 'No prazo',
  2: 'Atrasado',
  3: 'Em aprovação',
  4: 'Concluído',
  5: 'Cancelado',
  // Legacy frontend IDs (10-based)
  [SvcModalActionPlanStatusId.Atrasado]: 'Atrasado',
  [SvcModalActionPlanStatusId.NoPrazo]: 'No prazo',
  [SvcModalActionPlanStatusId.EmAprovacao]: 'Em aprovação',
  [SvcModalActionPlanStatusId.Concluido]: 'Concluído',
  [SvcModalActionPlanStatusId.Cancelado]: 'Cancelado',
};
